import React, { useState } from "react";
import {
  FaApple,
  FaGooglePlay,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import microsoftImg from "../../assets/microsoftstore.png";
import RequestDemoButton from "../RequestDemoButton";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [demoEmail, setDemoEmail] = useState("");

  const handleDemoClick = (e) => {
    e.preventDefault();

    // Basic email validation
    if (demoEmail && !/^\S+@\S+\.\S+$/.test(demoEmail)) {
      alert("Please enter a valid email address");
      return;
    }

    // Store email in localStorage as backup
    if (demoEmail) {
      localStorage.setItem("demoEmail", demoEmail);
    }

    // Navigate to contact page with email state
    navigate("/contact", {
      state: { prefillEmail: demoEmail },
    });
  };

  return (
    <div className="bg-gray-900 text-white">
      {/* CTA Section */}
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Left Image */}
          <div className="w-1/4 flex justify-start -ml-10">
            <img
              src="https://web-static.wrike.com/tp/static/assets/img/cta/v3/center/dark/2.svg"
              alt="Wrike illustration left"
              className="w-full h-auto max-w-[488px]"
              width="488"
              height="593"
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Transform Your Workflow with JuvvalTech
            </h2>
            <p className="text-lg mb-8">
              Experience the power of AI-driven legal and communication
              solutions.
            </p>

            {/* Updated Form */}
            <form
              onSubmit={handleDemoClick}
              className="max-w-md mx-auto md:mx-0"
            >
              <div className="mb-4 flex gap-2">
                <label htmlFor="demo-email" className="sr-only">
                  Enter your business email
                </label>
                <input
                  type="email"
                  id="demo-email"
                  value={demoEmail}
                  onChange={(e) => setDemoEmail(e.target.value)}
                  placeholder="Enter your business email"
                  className="flex-1 px-4 py-3 rounded-l bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <RequestDemoButton onClick={handleDemoClick} />
              </div>
            </form>

            {/* Ratings */}
            <div className="mt-1 flex flex-col items-center md:items-start">
              <div className="flex items-center mb-2">
                <img
                  src="https://web-static.wrike.com/tp/storage/uploads/9ba09455-ff2a-425d-954a-5a14b9dbe8d8/stars.svg"
                  alt="5 star rating"
                  width="104"
                  height="20"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-gray-400">
                Trusted by legal professionals and courts nationwide
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-1/4 flex justify-end -mr-10">
            <img
              src="https://web-static.wrike.com/tp/static/assets/img/cta/v3/center/dark/5.svg"
              alt="Wrike illustration right"
              className="w-full h-auto max-w-[400px]"
              width="400"
              height="500"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-200 py-12 px-6 border-t border-gray-800">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Company */}
          <div>
            <div className="text-5xl font-bold text-white mb-3">JuvvalTech</div>
            <p className="text-sm leading-relaxed mb-4">
              AI-powered solutions bridging communication gaps in legal systems
              and beyond.
            </p>
            <div className="flex gap-4 text-4xl">
              <a
                href="https://www.linkedin.com/company/moli-interpreter-scheduling-software/"
                className="hover:text-white transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.youtube.com/@MyMoliApp"
                className="hover:text-white transition"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white text-2xl mb-3 font-bold">Products</h3>
            <ul className="space-y-2 text-md font-semibold">
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Moli Interpretation Platform
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  AI-Terp Real-time Translation
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Kulu Legal Workflow
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Moli Admin Dashboard
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white text-2xl mb-3 font-bold">Resources</h3>
            <ul className="space-y-2 text-md font-semibold">
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  API Integration
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition">
                  Legal Compliance
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Apps */}
          <div>
            <h3 className="text-white text-2xl mb-3 font-bold">Get Our Apps</h3>
            <div className="flex items-center gap-4">
              <a
                href="https://apps.apple.com/us/app/moli-app/id6479742909"
                target="_blank"
                rel="noopener noreferrer"
                title="App Store"
              >
                <img
                  src="https://web-static.wrike.com/tp/static/assets/img/footer/app-store_en.svg"
                  alt="App Store"
                  loading="lazy"
                  width="135"
                  height="40"
                  className="hover:opacity-80 transition"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.juvvaltech.moli&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                title="Google Play"
              >
                <img
                  src="https://web-static.wrike.com/tp/static/assets/img/footer/google-play_en.svg"
                  alt="Google Play"
                  loading="lazy"
                  width="135"
                  height="40"
                  className="hover:opacity-80 transition"
                />
              </a>
              <a
                href="https://apps.microsoft.com/detail/9NZKMQRD07L8?hl=en-us&gl=IN&ocid=pdpshare"
                target="_blank"
                rel="noopener noreferrer"
                title="Microsoft Store"
              >
                <img
                  src={microsoftImg}
                  alt="Microsoft Store"
                  loading="lazy"
                  width="135"
                  height="40"
                  className="hover:opacity-80 transition"
                />
              </a>
            </div>

            <div className="mt-6">
              <h4 className="text-white text-2xl font-bold mb-2">Contact Us</h4>
              <p className="text-sm mb-2">contact@juvvaltech.com</p>
              <p className="text-sm mb-2">+1 (317) 883-9894</p>
            </div>
          </div>
        </div>

        <hr className="my-6 border-gray-700" />
        <div className="text-center text-xs text-gray-500">
          <p>
            © 2025 JuvvalTech, Inc. All rights reserved. |{" "}
            <Link to="/privacy-policy" className="underline hover:text-white">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-service" className="underline hover:text-white">
              Terms of Service
            </Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
